/**
 * Groups API - Settings
 *
 * Update group settings.
 */

import { z } from 'zod'
import { GroupSettingsAPISchema, GroupSettingsUpdateSchema } from './common'

// ============================================================================
// PATCH /v1/groups/:group_id/settings
// ============================================================================

// Partial-update body: every toggle optional, unknown keys rejected.
export const UpdateGroupSettingsRequestSchema = GroupSettingsUpdateSchema

export type UpdateGroupSettingsRequest = z.infer<typeof UpdateGroupSettingsRequestSchema>

// Response echoes the group's effective settings after the write so clients
// can reconcile optimistic state against the persisted truth. `showInApp` is
// the canonical custom-space visibility flag (plan 004 KTD3); it is echoed
// alongside the six toggles so a leader's "turn on" write reflects back.
export const UpdateGroupSettingsResponseSchema = z.object({
  data: GroupSettingsAPISchema.extend({
    showInApp: z.boolean().optional()
  }),
  message: z.string()
})

export type UpdateGroupSettingsResponse = z.infer<typeof UpdateGroupSettingsResponseSchema>
